import React, {useState} from 'react';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faSquareMinus } from '@fortawesome/free-regular-svg-icons';

// Определяем тип для узла дерева
interface TreeNodeProps {
    name: string;
    url?: string,
    children?: TreeNodeProps[];
}
// export const Sidebar: FC<{ versionId: string }> = ({versionId}) => {
const TreeNode: React.FC<{node: TreeNodeProps}> = ({node}) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleNode = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="menu-block">
                {node.children ? (
                    <span onClick={toggleNode} className="toggle"> {isOpen ? <FontAwesomeIcon icon={faSquareMinus} /> : <FontAwesomeIcon icon={faSquarePlus} />} </span>
                ) : null}
                {node?.url ? <Link to={node.url}><div className={node.children ? 'leaf' : 'leaf'}>{node.name}</div></Link> : node.name}
            {
            isOpen && node.children && (
                        <div className="menu-block-children">
                            {node.children.map((childNode, index) => (
                                <TreeNode key={index} node={childNode}/>
                            ))}
                        </div>
                    )
                }
            {/*</div>*/}
        </div>
    )
};

const TreeMenu: React.FC<{data: TreeNodeProps[]}> = ({data}) => {
    return (
        <div>
            {
                data.map((node, index) => (
                    <TreeNode
                        key={index}
                        node={node}/>
                ))
            }
        </div>
    );
};

export default TreeMenu;